module.exports = __webpack_public_path__ + "static/thalia-moore-d8741c62b3e3cb1bd9998d2c0c4a066d.jpg";